interface BaseNavItem {
  label: string;
  icon?: string;
}
export interface LinkNavItem extends BaseNavItem {
  href: string;
  permissions?: string[];
  /** Flag de configuration (configuration_config_param, module FEATURE_FLAG) requis pour afficher le lien. */
  featureFlag?: string;
}
export interface DropdownNavItem extends BaseNavItem {
  items: NavItem[];
}
export type NavItem = LinkNavItem | DropdownNavItem;

export const navItems: NavItem[] = [
  { label: "main.menu.items.home", icon: "home", href: "/home", permissions: ["ROLE_MENU_HOME"] },
  { label: "main.menu.items.tasks", icon: "task", href: "/task/list", permissions: ["ROLE_MENU_TASKS"] },
  { label: "main.menu.items.orders", icon: "store", href: "/order", permissions: ["ROLE_MENU_ORDER"] },
  { label: "main.menu.items.planning", icon: "calendar_month", href: "/deliverySchedule", permissions: ["ROLE_MENU_PLANNING"] },

  {
    label: "main.menu.items.commissions",
    icon: "workspace_premium",
    items: [
      { label: "main.menu.items.restitution", href: "/objective/gestion", permissions: ["ROLE_MENU_RESTITUTION"] },
      { label: "main.menu.items.insert_objectives", href: "/objectiveSales/list", permissions: ["ROLE_MENU_OBJ_INSERT"] },
      {
        label: "main.menu.items.administration",
        items: [
          { label: "main.menu.items.remuneration", href: "/remuneration/list", permissions: ["ROLE_MENU_REMUNERATION"] },
          { label: "main.menu.items.param_objectives", href: "/objective/list", permissions: ["ROLE_MENU_PARAM_OBJ"] },
        ],
      },
    ],
  },
  { label: "main.menu.ROLE_MENU_CFN", icon:"archive", href: "/vault/orders", permissions: ["ROLE_MENU_CFN"] },

  { label: "main.menu.items.third", icon: "group", href: "/third/list", permissions: ["ROLE_MENU_THIRD"] },

  {
    label: "main.menu.items.users",
    icon: "manage_accounts",
    items: [
      { label: "main.menu.items.accounts", href: "/userAdmin/list", permissions: ["ROLE_MENU_USERS"] },
      { label: "main.menu.items.delegations", href: "/delegation/list", permissions: ["ROLE_MENU_DELEGATIONS"] },
      { label: "main.menu.items.absence", href: "/GestionDabsence", permissions: ["ROLE_MENU_ABSENCES"] },
      { label: "main.menu.items.teams", href: "/team/list", permissions: ["ROLE_MENU_TEAMS"] },
    ],
  },

  {
    label: "main.menu.items.configuration",
    icon: "settings",
    items: [
      { label: "main.menu.items.general", href: "/configuration/general", permissions: ["ROLE_ADMIN"] },
      {
        label: "main.menu.items.organizations",
        items: [
          { label: "main.menu.items.networks", href: "/network/list", permissions: ["ROLE_MENU_NETWORKS"] },
          { label: "main.menu.items.groups", href: "/group/list", permissions: ["ROLE_MENU_GROUPS"] },
          { label: "main.menu.items.authorities", href: "/authority/list", permissions: ["ROLE_MENU_AUTHORITIES"] },
        ],
      },

      {
        label: "main.menu.items.documents",
        items: [
          { label: "main.menu.items.documents_type", href: "/documentType/list", permissions: ["ROLE_MENU_DOCUMENTS"] },
          { label: "main.menu.items.documents_family", href: "/documentFamily/list", permissions: ["ROLE_MENU_DOCUMENTS"] },
        ],
      },

      {
        label: "main.menu.items.actions",
        items: [
          { label: "main.menu.items.actions_create", href: "/action/list", permissions: ["ROLE_MENU_ACTIONS"] },
          { label: "main.menu.items.actions_context_create", href: "/actionContext/list", permissions: ["ROLE_MENU_ACTIONS"] },
        ],
      },

      { label: "main.menu.items.availabilities", href: "/availability/list", permissions: ["ROLE_MENU_AVAILABILITIES"] },
      { label: "main.menu.items.asset", href: "/good/list", permissions: ["ROLE_MENU_ASSETS"] },
      { label: "main.menu.items.aides", href: "/aides/list", permissions: ["ROLE_MENU_AIDES"] },
      { label: "main.menu.items.signature_templates", href: "/configuration/signatureTemplate" },
      { label: "main.menu.items.email_config", href: "/configuration/emailConfig" },
      { label: "misiv.settings.menu", href: "/configuration/misiv", permissions: ["ROLE_ADMIN"] },
      { label: "main.menu.items.recipient_whitelist", href: "/configuration/recipient-whitelist", permissions: ["ROLE_ADMIN"], featureFlag: "RECIPIENT_WHITELIST" },
      { label: "main.menu.items.menu", href: "/role-menu", permissions: ["ROLE_MENU_ROLE_MENU_CONFIG"] },
    ],
  },
];
